import React, { useEffect } from "react";
import { Chip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useQueryClient } from "react-query";
import _without from "lodash/without";
import { array, string } from "prop-types";

const ChipCmp = (props: any) => {
  let isNotArray;
  if (props.enamValue == props.item && props.enamValue != undefined) {
    isNotArray = true;
  }

  const queryClient = useQueryClient();

  const [multiselectName, setMultiselectName] = React.useState<string[]>();
  const [selectName, setSelectName] = React.useState<string>();
  useEffect(() => {
    setMultiselectName(props.item);
  }, []);
  const handleDelete = (e: React.MouseEvent, value: string) => {
    e.preventDefault();
    setMultiselectName(
      multiselectName
        ?.filter((item: any) => item != value)
        .map((item: any) => {
          return item;
        })
    );
    props.setChildValue(value);
  };
  const handleDeleteIsString = (e: React.MouseEvent, value: string) => {
    e.preventDefault();
    setSelectName("");
    props.setChildValue(value);
  };
  return (
    <div style={{ marginTop: "1vh", display: "inline-block" }}>
      {!isNotArray ? (
        props.item?.map((item: any, index: number) => (
          <>
            {props.enamValue
              ?.filter((items: any) => items.id == item)
              .map((itemm: any) => (
                <>
                  <Chip
                    sx={{
                      borderRadius: 1,
                      backgroundColor: "#EDEFEF !important",
                      marginLeft: "8px !important",
                      height: "25px",
                      marginTop: "10px",
                    }}
                    label={
                      <b
                        style={{
                          fontSize: "12px",
                          color: "#34495E",
                          fontFamily: "iranSans",
                          fontWeight: "lighter",
                        }}
                      >
                        {itemm.title}
                      </b>
                    }
                    deleteIcon={
                      <ClearIcon
                        style={{
                          color: "#34495E",
                          margin: "5px",
                          width: "15px",
                        }}
                      />
                    }
                    onDelete={(e) => handleDelete(e, itemm.id)}
                  />
                </>
              ))}
          </>
        ))
      ) : props.enamValue != "" ? (
        <Chip
          sx={{
            borderRadius: 1,
            backgroundColor: "#EDEFEF !important",
            marginLeft: "8px !important",
            height: "25px",
            marginTop: "10px",
          }}
          label={
            <b
              style={{
                fontSize: "12px",
                color: "#34495E",
                fontFamily: "iranSans",
                fontWeight: "lighter",
              }}
            >
              {props.enamValue.toLocaleString("fa")}
            </b>
          }
          deleteIcon={
            <ClearIcon
              style={{ color: "#34495E", margin: "5px", width: "15px" }}
            />
          }
          onDelete={(e) => handleDeleteIsString(e, props.enamValue)}
        />
      ) : null}
    </div>
  );
};

export default ChipCmp;
